/**
 * lang.js
 */
const BASEURI = '/common' + '_' + localStorage.getItem('DemoLanguage');

// 配置网站支持的语言
const langs = {
    en: 'en',
    'zh-cn': 'zh-CN'
}

// en cn 106 63
const languages = {
    en: 'en',
    'zh-CN': 'cn'
}
const tids = {
    en: '106',
    'zh-CN': '63'
}

const getLanguage = lang => {
    return languages[lang] || 'en'
}

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
    let lowerLang = (window.navigator.language ||
        window.navigator.browserLanguage ||
        'en').toLowerCase()

    // default: en
    return langs[lowerLang] || 'en'
}

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = lang => {
    // documentElement 根root HTML
    document.documentElement.setAttribute('lang', lang)
}


export const getProductstypeUrl = lang => {
    const language = getLanguage(lang)
    const tid = tids[lang] || '106'
    return `${BASEURI}/productstype.php?language=${language}&tid=${tid}&num=100`
}


//获取首页的内容
export const getHomeInfo = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getIndex.php`
}


//获取分类
export const getClass = (cid) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getClass.php?cid=${cid}`
}


//获取About的内容
export const getAbout = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getAbout.php`
}



//获取人力资源的内容
export const getJoin = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getJoin.php`
}


//获取解决方案内容
export const getSolution = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getSolution.php`
}

//获取底部新闻内容
export const getFooter = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getFooter.php  `
}


//下载中心
export const getDownload = (cid) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getDownload.php?cid=${cid}`
}

//加载更多下载中心
export const moreDownload = (cid, num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreDownload.php?cid=${cid}&num=${num}`
}


//帮助中心
export const getHelp = () => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getHelp.php`
}

//加载更多帮助
export const moreHelp = (num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreHelp.php?num=${num}`
}

//获取解决方案内页内容
export const getSolutionPage = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getSolutionPage.php?id=${id}`
}





//获取新闻的内容
export const getNews = (cid) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getNews.php?cid=${cid}`
}



//加载更多新闻
export const moreNews = (cid, num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreNews.php?cid=${cid}&num=${num}`
}


//获取新闻详情
export const getNewsPage = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getNewsPage.php?id=${id}`
}

//加载更多新闻
export const getNewsList = (num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreNews.php?num=${num}`
}


//产品中心
export const getProducts = (cid) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getProducts.php?cid=${cid}`
}


//加载更多产品
export const moreProducts = (cid, num) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/moreProducts.php?cid=${cid}&num=${num}`
}



//获取产品详情
export const getProInfo = (id) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/getProductPage.php?id=${id}`
}

//获取搜索的产品中文
export const getSearch = (keyword) => {
    // const language = getLanguage(lang)
    return `${BASEURI}/search.php?keyword=${keyword}`
}